import { to } from 'await-to-js';
import { getToken, removeToken, setToken } from '@/utils/auth';
import { login as loginApi } from '@/api/login';
import { LoginData } from '@/api/types';
import defAva from '@/assets/images/profile.jpg';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getInfoApi, type BrandUserInfo } from '@/api/brand/user';
import { useBrandStore } from '@/store/modules/brand';
import { useTagsViewStore } from '@/store/modules/tagsView';

/** 默认密码提醒在当前登录会话中的存储键前缀。 */
export const DEFAULT_PASSWORD_REMINDER_KEY_PREFIX = 'default-password-reminded:';

export const useUserStore = defineStore('user', () => {
  const token = ref(getToken());
  const name = ref('');
  const nickname = ref('');
  const userInfoData = ref<BrandUserInfo | null>(null);
  const userId = ref<string | number>('');
  const tenantId = ref<string>('');
  const tenantIdShow = ref(false);
  const avatar = ref('');
  const roles = ref<Array<string>>([]); // 用户角色编码集合 → 判断路由权限
  const permissions = ref<Array<string>>([]); // 用户权限编码集合 → 判断按钮权限

  /**
   * 登录
   * @param userInfo
   * @returns
   */
  const login = async (userInfo: LoginData): Promise<void> => {
    const [err, res] = await to(loginApi(userInfo));
    if (res) {
      console.log('登录成功', res);
      const data = res.data;
      // 新登录会话移除旧账号的默认密码提醒记录。
      Object.keys(sessionStorage)
        .filter((key) => key.startsWith(DEFAULT_PASSWORD_REMINDER_KEY_PREFIX))
        .forEach((key) => sessionStorage.removeItem(key));
      setToken(data.access_token);
      // token.value = data.access_token;
      // return Promise.resolve();
    }
    return Promise.reject(err);
  };
  const settenantId = (id) => {
    tenantId.value = id;
  };
  const getInfo = async (): Promise<void> => {
    const [err, res] = await to(getInfoApi());

    if (res) {
      const data = res.data;
      const user = data.user;
      const profile = user.avatar == '' || user.avatar == null ? defAva : user.avatar;
      userInfoData.value = user;
      if (data.permissions && data.permissions.length > 0) {
        // 验证返回的roles是否是一个非空数组
        roles.value = data.permissions;
        permissions.value = data.menuPermission;
      } else {
        roles.value = ['ROLE_DEFAULT'];
      }
      name.value = user.userName;
      nickname.value = user.nickName;
      avatar.value = profile;
      userId.value = user.userId;
      tenantId.value = user.tenantId;
      // 登录后的用户信息加载成功时，同步当前租户作为品牌信息
      useBrandStore().setBrandFn({
        brandName: user.tenantName ?? '',
        brandId: user.tenantId,
      });
      return Promise.resolve();
    }

    return Promise.reject(err);
  };
  // // 获取用户信息
  // const getInfo = async (): Promise<void> => {
  //   const [err, res] = await to(getUserInfo());
  //   if (res) {
  //     const data = res.data;
  //     const user = data.user;
  //     const profile = user.avatar == '' || user.avatar == null ? defAva : user.avatar;
  //
  //     if (data.roles && data.roles.length > 0) {
  //       // 验证返回的roles是否是一个非空数组
  //       roles.value = data.roles;
  //       permissions.value = data.permissions;
  //     } else {
  //       roles.value = ['ROLE_DEFAULT'];
  //     }
  //     name.value = user.userName;
  //     nickname.value = user.nickName;
  //     avatar.value = profile;
  //     userId.value = user.userId;
  //     tenantId.value = user.tenantId;
  //     return Promise.resolve();
  //   }
  //   return Promise.reject(err);
  // };

  // 注销
  const logout = async (): Promise<void> => {
    // await logoutApi() //  不用退出登录   直接删除
    token.value = '';
    roles.value = [];
    permissions.value = [];
    removeToken();
    // 会话失效时连同固定页签和外链缓存一起清除，避免重新登录后残留旧权限页面。
    const tagsViewStore = useTagsViewStore();
    tagsViewStore.visitedViews = [];
    tagsViewStore.cachedViews = [];
    tagsViewStore.iframeViews = [];
    tagsViewStore.isMainType = 1;
  };
  // 登录未选择租户
  const tenantFn = async (): Promise<void> => {
    console.log('tenantFn');

    tenantIdShow.value = true;
  };

  const setAvatar = (value: string) => {
    avatar.value = value;
  };

  return {
    userId,
    tenantId,
    token,
    nickname,
    avatar,
    roles,
    permissions,
    tenantIdShow,
    userInfoData,
    tenantFn,
    login,
    getInfo,
    logout,
    settenantId,
    setAvatar,
  };
});
